import { CompanyDefaultSurveyType } from 'src/types';

export type SurveyKeys = 'selfSurvey' | 'manualSurvey' | 'sampleAiSelfSurvey';

const SURVEY_TYPE_OPTIONS: Record<SurveyKeys, { key: CompanyDefaultSurveyType; name: string }> = {
  selfSurvey: { key: 'self_survey', name: 'AI Self Survey' },
  manualSurvey: { key: 'manual_survey', name: 'Manual Survey' },
  sampleAiSelfSurvey: {
    key: 'sample_ai_self_survey',
    name: 'Sample Survey (AI Self Survey)',
  },
} as const;

export const getAllowedSurveyTypeOptions = ({
  isNoReviewCompany,
  shouldIncludeSampleSurvey = true,
}: {
  isNoReviewCompany?: boolean;
  shouldIncludeSampleSurvey?: boolean;
}) => {
  const { selfSurvey, manualSurvey, sampleAiSelfSurvey } = SURVEY_TYPE_OPTIONS;
  const allowedOptions = [selfSurvey];

  if (!isNoReviewCompany) {
    allowedOptions.push(manualSurvey);
  }

  if (shouldIncludeSampleSurvey) {
    allowedOptions.push(sampleAiSelfSurvey);
  }

  return allowedOptions;
};
